enum CUSTOM_SECTION_CONTAINER_TYPES {
  BANNER_DISPLAY = 'Banner Display',
  PRODUCT_DISPLAY = 'Product Display',
  PARTNER_PRODUCT_DISPLAY = 'Partner Product Display',
  CATEGORY_DISPLAY = 'Category Display',
  PRODUCT_CARD = 'Product Card',
  PARTNER_PRODUCT_CARD = 'Partner Product Card',
  PRODUCT_DETAILS = 'Product Details',
}

export default CUSTOM_SECTION_CONTAINER_TYPES
